module.exports = __webpack_public_path__ + "img/scroll-2.fbb22351.jpg";